// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l6pdhDGcFefGHGkNVHkx{align-items:center;border:solid 1px var(--add-tooltip-border-color);border-radius:100%;display:flex;height:36px;justify-content:center;margin:18px;width:36px}.ccRL_VSLZdTn3syLuqVB{border-radius:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `l6pdhDGcFefGHGkNVHkx`,
	"image": `ccRL_VSLZdTn3syLuqVB`
};
export default ___CSS_LOADER_EXPORT___;
